import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Calendar, MapPin, ArrowRight, Star, Clock, Tag } from "lucide-react";

const EventsSection = ({ events }) => {
  const defaultEvents = [
    {
      id: "hyderabad-2027",
      name: "The FinRun Hyderabad 2027",
      edition: "3rd Edition",
      date: "February 7, 2027",
      location: "Gachibowli Stadium, Hyderabad",
      description: "India's First & Largest Cyber Awareness Run returns to Hyderabad! Join thousands of runners in spreading the message of digital safety.",
      image: "https://customer-assets.emergentagent.com/job_chennai-finrun/artifacts/32jrksgc_DR6A3677.JPG",
      flagship: true,
      pricing: { "3k": 799, "5k": 999, "10k": 1199 },
      earlyBird: null
    }
  ];

  const displayEvents = defaultEvents;

  return (
    <section id="events" className="section-spacing bg-white" data-testid="events-section">
      {/* Kinetic Text Ribbon */}
      <div className="kinetic-ribbon py-4 mb-16">
        <div className="kinetic-ribbon-content">
          {[...Array(10)].map((_, i) => (
            <span key={`ribbon-${i}`} className="text-[#FFD700]">
              CYBER AWARENESS • RUN FOR SAFETY • PROTECT DIGITAL TRUST •
            </span>
          ))}
        </div>
      </div>

      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#FF3B30] text-sm uppercase tracking-[0.2em] font-bold mb-4">
            Upcoming Event
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#0A0A0A] font-['Outfit'] mb-4">
            Join The Movement
          </h2>
          <p className="text-[#4B5563] text-lg max-w-2xl mx-auto">
            Be part of India's largest cyber awareness running movement.
          </p>
        </div>

        {/* Event Card - Single Featured */}
        <div className="max-w-3xl mx-auto">
          {displayEvents.map((event) => (
            <div
              key={event.id}
              className="group relative bg-white rounded-3xl overflow-hidden shadow-xl card-hover"
              data-testid={`event-card-${event.id}`}
            >
              {/* Image */}
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={event.image}
                  alt={event.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                
                {/* Edition Badge */}
                <div className="absolute top-4 left-4 flex items-center gap-2 bg-[#FF3B30] text-white rounded-full px-4 py-1.5">
                  <Star className="w-4 h-4" fill="currentColor" />
                  <span className="text-xs font-bold uppercase tracking-wider">{event.edition}</span>
                </div>

                {/* Event Info Overlay */}
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <h3 className="text-3xl font-bold font-['Outfit'] mb-2">{event.name}</h3>
                  <div className="flex flex-wrap items-center gap-4 text-sm">
                    <div className="flex items-center gap-1.5">
                      <Calendar className="w-4 h-4 text-[#FFD700]" />
                      <span>{event.date}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <MapPin className="w-4 h-4 text-[#FF3B30]" />
                      <span>{event.location}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <p className="text-[#4B5563] text-lg mb-6">{event.description}</p>
                
                {/* Pricing */}
                <div className="bg-[#FAFAFA] rounded-xl p-6 mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-lg font-semibold text-[#0A0A0A]">Registration Fees</span>
                  </div>
                  <div className="grid grid-cols-3 gap-4 text-center">
                    <div className="bg-white rounded-xl p-4 shadow-sm">
                      <p className="text-sm text-[#4B5563] mb-1">3K Fun Run</p>
                      <p className="text-2xl font-bold text-[#FFD700]">₹{event.pricing["3k"]}</p>
                    </div>
                    <div className="bg-white rounded-xl p-4 shadow-sm ring-2 ring-[#FF3B30]">
                      <p className="text-sm text-[#4B5563] mb-1">5K Timed</p>
                      <p className="text-2xl font-bold text-[#FF3B30]">₹{event.pricing["5k"]}</p>
                      <p className="text-xs text-[#FF3B30]">Most Popular</p>
                    </div>
                    <div className="bg-white rounded-xl p-4 shadow-sm">
                      <p className="text-sm text-[#4B5563] mb-1">10K Timed</p>
                      <p className="text-2xl font-bold text-[#007AFF]">₹{event.pricing["10k"]}</p>
                    </div>
                  </div>
                </div>
                
                {/* Categories */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {["3K Fun Run", "5K Timed", "10K Timed", "Cash Prizes", "Finisher Medal", "Event T-Shirt"].map((cat) => (
                    <span 
                      key={cat}
                      className="bg-[#FAFAFA] text-[#4B5563] px-4 py-2 rounded-full text-sm font-medium"
                    >
                      {cat}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <Link to={`/register/${event.id}`}>
                  <Button 
                    className="w-full btn-primary rounded-xl py-6 font-semibold text-lg"
                    data-testid={`register-${event.id}-btn`}
                  >
                    Register Now
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
